<template>
  <v-btn icon small @click="submit" :disabled="loading">
    <v-icon v-if="upvote">arrow_drop_up</v-icon>
    <v-icon v-else>arrow_drop_down</v-icon>
  </v-btn>
</template>

<script>
import ToolProcess from "../../models/ToolProcess";
export default {
  name: "ToolProcessVote",
  props: {
    upvote: {
      type: Boolean,
      required: true,
      default: true
    },
    processid: {
      type: [String, Number],
      required: true
    },
    currentPriority: {
      type: Number,
      required: true,
      default: 0
    }
  },
  data() {
    return {
      loading: false
    }
  },
  // For an upvote we add 1 to priorty
  // For a downvote we subtract 1 to a priority
  methods: {
    submit() {
      this.loading = true;
      let newPriority;
      if (this.upvote) {
        newPriority = this.currentPriority + 1;
      } else {
        newPriority = this.currentPriority - 1;
      }
      ToolProcess
        .$patch(this.processid, { priority: newPriority })
        .then(() => this.loading = false)
    }
  }
}
</script>
